module.exports = __webpack_public_path__ + "static/media/404.a8121abe.gif";